import React from "react";
import "../../../resources/css/skeleton.css";

const SkeletonElement = ({ type }) => {
    const classes = `skeleton ${type}`;
    
    return (
        <div className={classes}>
            <Shimmer />
        </div>
    );
}

const TrtmtEdu = () => {
  return <div style={{ display: "flex", gap: "14px" }}></div>;
};

const Shimmer = () => {
  return (
    <div className="shimmer-wrapper">
      <div className="shimmer"></div>
    </div>
  );
};

export default SkeletonElement;